import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAfricanCustomizeBoy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 321,
	height: 320,
	viewBox: "0 0 321 320",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M208.83 75.3104C209.442 74.2809 209.842 73.14 210.007 71.9542",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.484 126.644C207.801 121.451 204.688 116.18 199.529 114.872C194.371 113.563 189.121 116.712 187.803 121.905C186.486 127.098 189.599 132.368 194.758 133.677C199.916 134.986 205.166 131.837 206.484 126.644Z",
			fill: "#89E1E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.6 123.913C182.918 118.72 179.804 113.449 174.646 112.14C169.487 110.832 164.238 113.981 162.92 119.174C161.602 124.367 164.716 129.637 169.874 130.946C175.033 132.255 180.283 129.106 181.6 123.913Z",
			fill: "#89E1E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.423 278.692C148.998 279.637 148.788 287.935 147.213 288.04C145.637 288.145 138.705 283.314 129.252 283.103C123.244 282.97 115.808 285.939 115.913 286.99C116.122 289.083 142.171 289.405 147.213 288.04",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.913 286.99C115.913 286.99 114.127 279.532 116.963 277.957C121.394 275.495 130.933 273.65 140.491 276.696C152.433 280.502 150.784 276.381 150.784 276.381",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.578 285.099C148.578 285.099 151.624 285.624 152.044 283.208",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.3673 253.577C61.3673 253.577 65.7501 265.347 59.7394 274.238",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M160.938 64.0206C160.938 64.0206 157.325 104.664 175.873 108.214C193.858 111.656 201.316 85.0166 201.316 85.0166",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M193.268 63.3254C160.762 50.0782 141.24 56.5672 138.568 63.9144C136.237 70.3244 160.527 72.4121 160.527 72.4121",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.134 54.4885C163.113 44.5299 166.839 32.3022 187.27 35.7035C187.27 35.7035 190.824 37.6172 188.5 60.9918",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M158.61 54.619C161.48 28.3738 187.27 35.7035 187.27 35.7035C187.27 35.7035 202.579 40.6245 205.587 44.9987C208.594 49.3729 209.567 60.617 206.697 69.502",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.309 74.3296C164.309 74.3296 164.186 78.3247 164.901 78.2281C165.616 78.1315 165.567 73.0851 164.309 74.3296Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.205 66.1538C177.205 66.1538 180.984 62.1727 186.539 68.1253",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.811 66.9383C166.811 66.9383 163.865 62.7601 159.34 67.5185",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.693 73.0536C179.692 74.3178 180.366 79.5901 181.62 78.4658C182.394 77.772 181.494 74.8686 180.764 75.1829",
			fill: "#3B57F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M180.693 73.0536C179.692 74.3178 180.366 79.5901 181.62 78.4658C182.394 77.772 181.494 74.8686 180.764 75.1829",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M178.344 84.2821C179.659 87.6749 174.397 87.2594 174.397 87.2594C170.356 89.4333 165.949 86.2208 167.901 83.5391C170.125 80.4841 169.799 75.377 169.285 71.8523",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.99 92.3187C182.99 92.3187 181.315 99.5773 176.439 97.3344C172.275 95.4188 181.353 94.3361 182.99 92.3187Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.23 99.3203C165.23 99.3203 161.587 100.948 161.432 106.297",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.178 114.365C162.26 114.365 163.137 112.559 163.137 110.331C163.137 108.103 162.26 106.297 161.178 106.297C160.095 106.297 159.218 108.103 159.218 110.331C159.218 112.559 160.095 114.365 161.178 114.365Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.178 106.297H163.581C164.663 106.297 165.54 108.103 165.54 110.331C165.54 112.559 164.663 114.365 163.581 114.365H161.178",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M170.682 127.607C172.266 127.84 173.845 127.076 173.936 125.938C174.229 122.273 174.958 115.23 175.743 111.296C175.966 110.177 174.655 109.202 173.234 108.996C171.55 108.752 170.326 109.488 170.039 110.592C168.958 115.402 168.353 120.306 168.232 125.234C168.28 125.861 168.556 126.448 169.007 126.885C169.459 127.322 170.054 127.579 170.682 127.607V127.607Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M168.189 124.832C167.076 124.413 166.44 123.82 166.36 123.227C166.14 119.363 166.618 115.49 167.772 111.796C167.983 111.288 168.675 110.893 169.794 110.755C169.794 110.755 168.565 109.371 164.309 109.049",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.743 111.296C175.839 116.238 175.23 121.168 173.936 125.938",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.503 114.53C162.856 117.354 163.97 120.029 165.727 122.269",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.188 126.869C114.188 126.869 108.34 107.722 109.154 104.566C109.713 102.399 126.423 101.21 127.409 103.519C127.873 104.605 131.527 121.556 131.992 125.143C131.992 125.143 119.124 128.515 114.188 126.869Z",
			fill: "#89E1E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.764 118.915C127.292 115.271 126.351 112.686 121.063 117.387C111.399 125.977 107.106 150.426 107.106 150.426",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.42 131.959C117.42 131.959 127.527 125.143 133.638 125.143C139.749 125.143 123.884 133.605 121.181 138.305C119.754 140.786 126.469 134.427 135.048 135.015",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.828 146.297C120.828 146.297 128.349 142.066 133.168 141.831",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.979 115.939C131.979 115.939 142.917 103.812 167.398 103.41",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.155 179.512C118.155 179.512 85.9109 227.28 104.569 250.696",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.219 268.399C117.278 263.882 131.397 254.442 131.397 254.442C152.06 262.191 155.848 250.826 142.589 252.376C134.522 253.319 109.197 264.57 113.182 256.215C116.438 249.388 131.397 254.442 131.397 254.442C131.397 254.442 151.903 260.403 154.88 276.276",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.596 261.675C137.596 261.675 130.656 261.135 126.231 264.085C122.615 266.496 139.86 265.563 143.011 268.924C143.011 268.924 138.81 262.937 121.69 272.075",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.049 244.556C150.049 244.556 147.528 263.462 150.049 272.6",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.311 245.922L129.008 254.471C129.008 254.471 130.906 261.844 124.52 269.859",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.34 259.086C116.34 259.086 115.463 252.575 103.943 254.453C92.4224 256.331 79.6278 253.688 75.5174 252.825C62.9951 250.196 48.7198 256.582 51.4747 267.226C54.2296 277.87 82.655 277.369 82.655 277.369",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.7838 254.328C77.3957 252.7 69.2251 249.91 62.369 250.446C54.3548 251.072 46.0901 255.705 47.4676 265.097C48.845 274.489 62.6195 275.49 62.6195 275.49",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.877 274.113C66.877 274.113 72.2616 267.351 71.7607 259.712C71.2598 252.074 76.5191 268.728 74.3904 273.612C72.2616 278.496 74.5156 259.337 78.8984 259.462C83.2811 259.587 86.036 270.857 85.1595 273.111",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1666 262.593C89.1666 262.593 90.7945 268.854 89.4171 274.238",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.7998 275.24C93.7998 275.24 93.2989 268.228 95.052 266.099C97.6596 262.932 104.569 283.88 106.573 279.122C109.188 272.91 98.8087 260.965 98.6835 268.478C98.5583 275.991 97.1808 278.245 89.7927 280.875",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.963 277.957C116.963 277.957 110.414 272.263 114.582 259.761C114.582 259.761 106.888 257.677 103.682 264.088C101.919 267.615 107.369 271.301 101.278 277.873",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.416 199.06C156.416 199.06 155.212 233.696 157.494 236.586",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.423 211.975C156.423 211.975 170.825 213.121 182.64 219.591C189.436 223.313 192.142 229.179 198.966 234.189",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M121.991 98.5558L121.815 91.7175C121.815 91.7175 129.804 91.3495 131.324 90.2377C134.064 88.2322 138.013 38.4445 136.213 35.9248C134.413 33.4051 43.3453 33.7651 41.1855 37.0047C39.0258 40.2442 41.5455 85.5983 44.0652 89.5578C46.5848 93.5173 112.816 92.0775 112.816 92.0775L121.991 98.5558Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.12 95.4216L117.943 88.5834C117.943 88.5834 125.933 88.2154 127.452 87.1036C130.192 85.098 134.141 35.3103 132.342 32.7907C130.542 30.271 39.4737 30.631 37.314 33.8705C35.1542 37.1101 37.674 82.4642 40.1936 86.4237C42.7132 90.3831 108.945 88.9433 108.945 88.9433L118.12 95.4216Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M202.244 74.9188C202.244 74.9188 208.399 70.8989 209.263 77.62C210.165 84.6372 204.517 87.7909 201.006 87.2922",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M202.832 90.0406C202.832 90.0406 199.648 101.568 203.711 110.145",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M202.075 122.582C203.103 119.021 203.17 115.913 202.225 115.64C201.279 115.367 199.68 118.033 198.652 121.594C197.624 125.154 197.557 128.262 198.502 128.535C199.447 128.808 201.047 126.143 202.075 122.582Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M201.406 112.338L198.313 111.536C196.43 110.992 193.707 114.694 192.232 119.804C190.757 124.913 191.088 129.496 192.972 130.04L196.065 130.842",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M202.146 122.575C203.621 117.465 203.29 112.882 201.406 112.338C199.523 111.794 196.8 115.496 195.325 120.606C193.849 125.715 194.181 130.298 196.065 130.842C197.948 131.386 200.671 127.685 202.146 122.575Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.934 117.758C210.491 115.601 210.165 113.652 209.206 113.404C208.247 113.156 207.018 114.704 206.461 116.861C205.903 119.019 206.229 120.968 207.188 121.216C208.148 121.464 209.377 119.916 209.934 117.758Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.189 121.216L205.059 120.666C204.1 120.418 203.774 118.469 204.331 116.312C204.888 114.154 206.117 112.606 207.076 112.854L209.206 113.404",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.076 112.854C207.076 112.854 207.902 104.405 202.228 100.923",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M199.455 128.524C199.455 128.524 205.645 126.847 206.29 120.721",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.93 115.054C205.34 114.71 203.681 114.916 202.224 115.64",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.564 43.8258C204.564 43.8258 215.274 54.8373 211.107 72.9159C211.107 72.9159 195.564 57.5668 163.548 62.7156C154.709 64.1371 160.224 69.4551 160.224 69.4551",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.841 128.303C174.571 134.58 185.062 138.242 194.168 130.522",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.7776 62.1152C71.1302 56.7841 67.9338 51.3732 62.6382 50.0297C57.3427 48.6861 51.9533 51.9186 50.6007 57.2498C49.2482 62.5809 52.4446 67.9918 57.7401 69.3353C63.0356 70.6789 68.425 67.4463 69.7776 62.1152Z",
			fill: "#89E1E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.2733 48.5191L82.0977 46.8872L78.8364 69.2203L90.0121 70.8523L93.2733 48.5191Z",
			fill: "#DDC1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.454 184.75L199.42 190.357L180.913 145.821L156.158 178.16L156.454 184.75Z",
			fill: "#C2D1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.508 50.069L97.9681 68.325H119.048L108.508 50.069Z",
			fill: "#C2D1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.901 167.061C112.945 193.069 126.158 247.995 126.158 247.995C126.158 247.995 126.528 238.339 138.245 238.09C149.961 237.841 150.496 246.778 150.496 246.778C150.496 246.778 151.797 232.215 154.565 216.092C158.766 191.619 155.607 169.389 155.57 165.3C155.514 159.274 150.333 146.516 140.987 146.105C138.407 145.992 132.757 146.367 130.392 148.349C125.966 152.059 122.543 161.696 120.901 167.061Z",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M283.59 156.889H225.819V280.51H283.59V156.889Z",
			fill: "#DDC1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M268.259 139.443C268.259 139.443 260.727 135.001 241.618 140.885C235.254 142.835 228.619 143.757 221.964 143.614",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.635 142.912C216.635 142.912 200.551 140.04 198.753 145.654C198.125 147.841 196.91 149.816 195.24 151.362",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M198.134 155.344C198.022 155.662 197.984 156.002 198.024 156.337C198.064 156.672 198.18 156.994 198.363 157.277C198.546 157.561 198.791 157.798 199.08 157.973C199.369 158.147 199.694 158.252 200.03 158.282C202.741 158.917 198.365 161.864 204.164 164.298C207.272 165.603 205.647 168.142 209.695 169.535C214.239 171.098 222.442 166.11 225.892 162.941",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M229.107 159.92C229.107 159.92 269.378 171.792 279.753 155.785C289.418 140.873 258.214 118.782 211.821 109.945",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.496 246.778C150.496 246.778 172.972 238.001 188.718 238.308C188.718 238.308 215.957 238.144 217.691 251.365C219.835 267.71 213.637 272.223 208.008 274.504C201.869 276.993 173.818 283.304 156.18 280.548",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M222.056 165.928C222.485 190.931 213.986 216.399 214.979 230.822C215.784 242.506 195.479 217.127 185.772 217.531C176.066 217.936 211.454 233.911 211.656 239.573",
			stroke: "#3B57F6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgAfricanCustomizeBoy);
export default ForwardRef;
